(function () {

  function normalizeSize(str) {
    return String(str || '').trim().replace(',', '.');
  }

  function getVariantData(card) {
    const script = card.querySelector('.variant-data');
    if (!script) return null;
    try { return JSON.parse(script.textContent); } catch (e) { return null; }
  }

  function findVariant(variantData, size) {
    const normalized = normalizeSize(size);
    return variantData.variants.find(v =>
      v.available && v.options.some(opt => normalizeSize(opt) === normalized)
    );
  }

  // ── Ocultar size-list en mobile via JS ───────────────────────
  function hideSizeListOnMobile() {
    if (window.innerWidth > 1024) return;
    document.querySelectorAll('.hdt-custom-size-list').forEach(el => {
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
    });
  }

  // ── Abrir cart drawer ────────────────────────────────────────
  function openCartDrawer() {
    const drawer = document.querySelector('#CartDrawer');
    if (!drawer) return;
    if (typeof drawer.showModal === 'function') drawer.showModal();
    else if (typeof drawer.show === 'function') drawer.show();
  }

  // ── Cart ─────────────────────────────────────────────────────
  function refreshCart() {
    const cartDrawerEl = document.querySelector('hdt-cart-drawer[section-id]');
    const sectionId = cartDrawerEl?.getAttribute('section-id');
    const cartComponent = document.querySelector('cart-items-component');

    fetch('/cart.js').then(r => r.json()).then(cart => updateCartCount(cart.item_count));

    if (!sectionId || !cartComponent) return;

    fetch(`/?sections=${sectionId}`)
      .then(r => r.json())
      .then(data => {
        const html = data[sectionId];
        if (!html) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');

        const newComponent = parsed.querySelector('cart-items-component');
        if (newComponent) cartComponent.innerHTML = newComponent.innerHTML;

        const newBottom = parsed.querySelector('[ref="cart-bottom"]');
        const currentBottom = cartComponent.querySelector('[ref="cart-bottom"]');
        if (newBottom && currentBottom) currentBottom.innerHTML = newBottom.innerHTML;

        const newCount = parsed.querySelector('hdt-cart-drawer[data-count]')?.getAttribute('data-count');
        if (newCount !== null) cartDrawerEl?.setAttribute('data-count', newCount);
      });
  }

  function updateCartCount(count) {
    const cartLink = document.querySelector('a.hdt-has-count-box[href="/cart"]');
    if (cartLink) {
      const counter = cartLink.querySelector('[class*="count"], [class*="badge"], [class*="bubble"]');
      if (counter) { counter.textContent = count; counter.hidden = count === 0; }
    }
    document.querySelectorAll('.cart-count-bubble span:not(.visually-hidden)').forEach(el => {
      el.textContent = count;
    });
    const bubble = document.querySelector('.cart-count-bubble');
    if (bubble) bubble.hidden = count === 0;
  }

  function addToCart(variantId, btn, originalText, onSuccess) {
    btn.disabled = true;
    btn.textContent = 'ADD TO CART';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
    })
      .then(res => { if (!res.ok) throw new Error('Cart error ' + res.status); return res.json(); })
      .then(() => {
        btn.textContent = 'ADDED';
        refreshCart();
        if (window.innerWidth > 1024) openCartDrawer();
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
          if (onSuccess) onSuccess();
        }, 1500);
      })
      .catch(err => {
        console.error('Quick Add error:', err);
        btn.textContent = 'Error – reintentar';
        btn.disabled = false;
        setTimeout(() => { btn.textContent = originalText; }, 2000);
      });
  }

  // ── Ocultar tallas sin stock en desktop ──────────────────────
  function hideUnavailableSizes(card) {
    card.querySelectorAll('.hdt-size-list-item.unavailable').forEach(item => {
      item.style.setProperty('display', 'none', 'important');
    });
  }

  // ── Auto-seleccionar primera talla disponible ────────────────
  function autoSelectFirstSize(card) {
    const variantData = getVariantData(card);
    if (!variantData) return;

    const sizeItems = card.querySelectorAll('.hdt-size-list-item');
    const firstAvailable = [...sizeItems].find(
      item => item.tagName !== 'A' && !item.classList.contains('unavailable')
    );
    if (firstAvailable) {
      sizeItems.forEach(b => b.classList.remove('active'));
      firstAvailable.classList.add('active');
      const variant = findVariant(variantData, firstAvailable.dataset.size);
      const btn = card.querySelector('.hdt-card-quick-add-btn');
      if (btn && variant) {
        btn.disabled = false;
        btn.dataset.variantId = String(variant.id);
      }
    }
  }

  // ── Desktop: selección de talla ──────────────────────────────
  document.addEventListener('click', function (e) {
    const sizeBtn = e.target.closest('.hdt-size-list-item');
    if (!sizeBtn || sizeBtn.tagName === 'A') return;
    const card = sizeBtn.closest('.hdt-card-product');
    if (!card) return;
    if (sizeBtn.classList.contains('unavailable')) {
      e.stopImmediatePropagation();
      return;
    }
    const variantData = getVariantData(card);
    if (!variantData) return;

    card.querySelectorAll('.hdt-size-list-item').forEach(b => b.classList.remove('active'));
    sizeBtn.classList.add('active');

    const variant = findVariant(variantData, sizeBtn.dataset.size);
    const btn = card.querySelector('.hdt-card-quick-add-btn');
    if (!btn) return;
    if (variant) {
      btn.disabled = false;
      btn.dataset.variantId = String(variant.id);
    } else {
      btn.disabled = true;
      btn.dataset.variantId = '';
    }
  }, true);

  // ── Desktop: add to cart ─────────────────────────────────────
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.hdt-card-quick-add-btn');
    if (!btn) return;
    const variantId = btn.dataset.variantId;
    if (!variantId || btn.disabled) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    addToCart(variantId, btn, btn.textContent.trim());
  }, true);

  // ── Mobile Sheet ─────────────────────────────────────────────
  function buildSheet() {
    if (document.getElementById('qa-mobile-sheet')) return;
    const sheet = document.createElement('div');
    sheet.id = 'qa-mobile-sheet';
    sheet.innerHTML = `
      <div id="qa-sheet-overlay"></div>
      <div id="qa-sheet-panel">
        <div id="qa-sheet-header">
          <button id="qa-sheet-close" aria-label="Cerrar">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M16 1.4L14.6 0L8 6.6L1.4 0L0 1.4L6.6 8L0 14.6L1.4 16L8 9.4L14.6 16L16 14.6L9.4 8L16 1.4Z" fill="currentColor"/>
            </svg>
          </button>
        </div>
        <div id="qa-sheet-sizes"></div>
        <button id="qa-sheet-atc" disabled>ADD TO CART</button>
      </div>
    `;
    document.body.appendChild(sheet);
    document.getElementById('qa-sheet-overlay').addEventListener('click', closeSheet);
    document.getElementById('qa-sheet-close').addEventListener('click', closeSheet);
    document.getElementById('qa-sheet-atc').addEventListener('click', function () {
      const variantId = this.dataset.variantId;
      if (!variantId || this.disabled) return;
      addToCart(variantId, this, 'ADD TO CART', closeSheet);
    });
  }

  function openSheet(card) {
    buildSheet();
    const variantData = getVariantData(card);
    if (!variantData) return;

    const sizesContainer = document.getElementById('qa-sheet-sizes');
    const atcBtn = document.getElementById('qa-sheet-atc');
    sizesContainer.innerHTML = '';
    atcBtn.disabled = true;
    atcBtn.dataset.variantId = '';

    const sizeItems = card.querySelectorAll('.hdt-size-list-item');
    let sizes = [];
    if (sizeItems.length > 0) {
      sizeItems.forEach(item => {
        if (item.tagName === 'A') return;
        const size = item.dataset.size;
        if (size) sizes.push({ size, unavailable: item.classList.contains('unavailable') });
      });
    } else {
      const allSizes = new Set();
      variantData.variants.forEach(v => v.options.forEach(o => allSizes.add(o)));
      allSizes.forEach(size => sizes.push({
        size,
        unavailable: !variantData.variants.some(v => v.available && v.options.includes(size))
      }));
    }

    let firstSelected = false;
    sizes.forEach(({ size, unavailable }) => {
      // No renderizar tallas sin stock en mobile
      if (unavailable) return;

      const btn = document.createElement('button');
      btn.className = 'qa-size-btn';
      btn.textContent = size;
      btn.dataset.size = size;

      // Auto-seleccionar la primera disponible
      if (!firstSelected) {
        firstSelected = true;
        btn.classList.add('qa-active');
        const variant = findVariant(variantData, size);
        if (variant) {
          atcBtn.disabled = false;
          atcBtn.dataset.variantId = String(variant.id);
        }
      }

      btn.addEventListener('click', function () {
        sizesContainer.querySelectorAll('.qa-size-btn').forEach(b => b.classList.remove('qa-active'));
        this.classList.add('qa-active');
        const variant = findVariant(variantData, this.dataset.size);
        if (variant) {
          atcBtn.disabled = false;
          atcBtn.dataset.variantId = String(variant.id);
        } else {
          atcBtn.disabled = true;
          atcBtn.dataset.variantId = '';
        }
      });
      sizesContainer.appendChild(btn);
    });

    document.getElementById('qa-mobile-sheet').classList.add('qa-open');
    document.body.style.overflow = 'hidden';
  }

  function closeSheet() {
    const sheet = document.getElementById('qa-mobile-sheet');
    if (!sheet) return;
    sheet.classList.remove('qa-open');
    document.body.style.overflow = '';
  }

  // ── Inyectar botón + y ocultar size-list en mobile ───────────
  function initCards() {
    hideSizeListOnMobile();
    document.querySelectorAll('.hdt-card-product').forEach(card => {
      if (card.querySelector('.qa-mobile-trigger')) return;
      hideUnavailableSizes(card);
      autoSelectFirstSize(card);
      const btn = document.createElement('button');
      btn.className = 'qa-mobile-trigger';
      btn.setAttribute('aria-label', 'Seleccionar talla');
      btn.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0763/0402/3794/files/5303652f-f605-4b74-bb23-82dd117dff98___9abcd6fbd5e192428ab509f4a682574a_1.webp?v=1772825981" alt="" width="20" height="20" style="object-fit:contain;display:block;">`;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openSheet(card);
      });
      const media = card.querySelector('.hdt-card-product__media');
      if (media) media.appendChild(btn);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCards);
  } else {
    initCards();
  }

  const observer = new MutationObserver(() => {
    hideSizeListOnMobile();
    initCards();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  window.addEventListener('resize', hideSizeListOnMobile);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeSheet(); });

})();